import { IAppointmentState } from '../Appointment/store/interface/IAppointmentState'
import { BookingRestoreState } from './types'

export function encodeBookingState(appointment: IAppointmentState): string {
  const state: BookingRestoreState = {
    customers: appointment.customers.map((customer) => ({
      activities: (customer.activities ?? []).map((activity) => ({
        id: activity.id,
        categoryId: activity.categoryId,
        type: activity.type,
        personId: activity.personSelected?.id,
      })),
    })),
    date: appointment.date,
    formData: appointment.customerFormData
      ? {
          firstName: appointment.customerFormData.firstName,
          lastName: appointment.customerFormData.lastName,
          phone: appointment.customerFormData.phone,
          email: appointment.customerFormData.email,
          sendEmail: appointment.customerFormData.sendEmail,
          customerPaysFullAmount: appointment.customerFormData.customerPaysFullAmount,
          street: appointment.customerFormData.street,
          city: appointment.customerFormData.city,
          zip: appointment.customerFormData.zip,
          comment: appointment.customerFormData.comment,
        }
      : undefined,
  }

  return btoa(JSON.stringify(state))
}
